<template>
  <b-container class='mb-3'>
    <h1>Connect With Us</h1>

    <h2>The CitSci Blog</h2>
    <p>
      <b-link href="https://blog.citsci.org" target="_blank">Follow us on our blog</b-link>. We love to share your citizen science success
      stories. Read more about the great projects we host and support. Stay
      informed about the latest features we launch regularly. Hop on over to our
      <IconLink href="https://blog.citsci.org"> blog</IconLink> today.
    </p>

    <p></p>
    <h2>Our e-Newsletter</h2>
    <p>
      We send roughly monthly newsletters with the latest in news and stories
      from CitSci. Read more about this communication and
      <b-link :to="'newsletter'">sign up to receive our newsletter</b-link>
      today.
    </p>
    <h2>Webinars</h2>
    <p>
      CitSci periodically hosts <b-link to="webinars">webinars</b-link> to help
      you do great citizen science. We often do these through the Citizen
      Science Association. Topics range from highlighting your projects and
      lessons learned to data management to best practices. Stay tuned. More
      details coming soon.
    </p>
    <h2>Surveys</h2>
    <p>
      Are you a researcher interested in studying the science of citizen
      science? Connect with the CitSci community through surveys you create to
      gain insights from real citizen science project leaders and participants.
      But before you do, <b-link to="surveys">read more</b-link> about our
      survey policy.
    </p>
    <h2>Contact Us</h2>
    <p>
      We love hearing from you. Drop us a line using our simple contact form on
      our <b-link to="contact">contact</b-link> page.
    </p>
  </b-container>
</template>

<script>
import IconLink from '../../components/layout/IconLink.vue';

export default {
  
  components: {IconLink}
}
</script>
